
type DispatchFunction = (payload: { type: string, data?: any }, cb?: () => void) => void;

export class ResponseHandler {

    constructor(private errorMessage: string, private dispatch: DispatchFunction) {

    }

    handle = (result: IJsonResult<any>, cb: () => void) => {
        if (result.success) {
            cb();
        } else {
            this.errors(result.errors);
        }
    }

    handleAsync = (result: IJsonResult<any>): Promise<void> => {
        return new Promise<void>((resolve, reject) => {
            if (result.success) {
                resolve();
            } else {
                this.errors(result.errors);
            }
        });
    }

    private errors = (errors: string[]) => {
        this.dispatchErrors(errors);
    }

    private dispatchErrors(errors: string[]) {
        this.dispatch({
            type: this.errorMessage,
            data: errors
        });
    }
}
